import { render, staticRenderFns } from "./groupRank.vue?vue&type=template&id=662d1934"
import script from "./groupRank.vue?vue&type=script&lang=js"
export * from "./groupRank.vue?vue&type=script&lang=js"
import style0 from "./groupRank.vue?vue&type=style&index=0&id=662d1934&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports